import quoteSlice from './quoteSlice';

export const quoteReducer = quoteSlice.reducer;
export const quoteActions = quoteSlice.actions;
